
import BaseDynamicComponent from "@/app/dynamic-components/forms/form-components/form-component.base";
import { validationRules } from "@/constants/ValidationRules";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TextField from "@/components/common/TextField.vue";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";

export type HeaderMetaData = unknown;

@Component({
  components: {DynamicComponentConfigManager},
})
export default class FormComponentText extends BaseDynamicComponent<any> {}
